module.exports = __webpack_public_path__ + "static/media/defaultCustomerAvatar.7821a18d.svg";